import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'arrayformation'
})
export class ArrayformationPipe implements PipeTransform {

  transform(Obj:any, ...args: unknown[]): unknown {
     
   let obj_value:any=[];
    for (const [value] of Object.entries(Obj)) {
      obj_value.push({key:value})
    }
    return obj_value;
  }

}
